export default "__VITE_ASSET__CR9Djxvy__"